const all = ['documents']
const detail = (docId: number) => [...all, docId]
const variable_data = (docId: number) => [...detail(docId), 'variable_data']

export const documentKeys = { all, detail, variable_data }
